import { BasePortalService } from './BasePortalService';

export default class OrderService extends BasePortalService {
    constructor() {
        super();
        this.reorderEndpoint = '/orderhistory/reorder';
    }

    async reorder(params) {
        const response = await this.post(this.reorderEndpoint, params);
        return response;
    }
}